import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { librarySettingsAPI } from '@/providers/apis/library/library';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'on-off-checkbox',
    components: {

    },
})

export default class OnOffCheckbox extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private value: any;

    @Prop()
    private disabled: any;

    private content: boolean = false;

    // ---------------------------------------------------------------------
    // Methods


    // -------------------------------------------------------------------
    // Hooks

    private created() {
        this.content = this.value ? this.value.toLowerCase() === 'on' ? true : false : false;
    }

    // ---------------------------------------------------------------------
    // Actions

    private onChangeConfig(item: any) {
        this.$emit('input', item ? 'on' : 'off');
    }

}
